var React = require('react');

function IconKibanaDO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.0107422 21.6135V24H1.1536L11.165 12.1576C10.4793 11.7073 9.74788 11.3021 9.01645 10.9418L0.0107422 21.6135Z","fill":"black","key":0}),React.createElement("path",{"opacity":"0.8","d":"M11.1652 12.1577L1.15381 24.0001H18.251C18.251 19.182 15.5081 14.8593 11.1652 12.1577Z","fill":"black","key":1}),React.createElement("path",{"d":"M0.0107422 0V21.6135L18.2965 0H0.0107422Z","fill":"black","key":2}),React.createElement("path",{"d":"M0.0107422 21.6134L9.01646 10.9418C6.18217 9.68098 3.11931 9.00555 0.0107422 9.00555V21.6134Z","fill":"black","key":3})]);
}

IconKibanaDO.defaultProps = {"width":"19","height":"24","viewBox":"0 0 19 24","fill":"none"};

module.exports = IconKibanaDO;

IconKibanaDO.default = IconKibanaDO;
